export const makeAuthHeader = (jwt: string) => ({
  AUTHORIZATION: `Bearer ${jwt}`,
});
